// Provider (Client-safe)
export { AuthProvider } from './provider';

// Types (Client-safe)
export type { AuthUser, AuthProvider as IAuthProvider, AuthSession } from './types';

// Resiliente Wrapper-Hooks/-Components (funktionieren auch ohne ClerkProvider)
export {
  useAuth,
  useUser,
  useClerk,
  useSignIn,
  useSignUp,
  Show,
  SignIn,
  SignUp,
  UserButton,
} from './client-hooks';

// Direkte Clerk-Exports für übrige Komponenten / Server-Utilities
export {
  SignInButton,
  SignUpButton,
  UserProfile,
  useSession,
  useOrganization,
} from '@clerk/nextjs';

export { auth, currentUser } from '@clerk/nextjs/server';
